// src/store/popupStore.ts
import { create } from "zustand"

export type PopupOpenMode = "replace" | "queue"
export type PopupOpenOptions = {
  mode?: PopupOpenMode
}

type PopupState = {
  isOpen: boolean
  content: React.ReactNode
  queue: React.ReactNode[]
  openPopup: (content: React.ReactNode, options?: PopupOpenOptions) => void
  closePopup: () => void
}

export const useGlobalPopupStore = create<PopupState>((set) => ({
  isOpen: false,
  content: null,
  queue: [],
  openPopup: (content, options) =>
    set((state) => {
      const mode = options?.mode ?? "replace"
      if (mode === "queue") {
        // 팝업이 열려 있고 유효한 content가 있을 때만 큐에 추가
        // content가 null인 상태는 유효한 팝업이 아니므로 제외
        if (state.isOpen && state.content !== null) {
          return { ...state, queue: [...state.queue, content] }
        }
        return { isOpen: true, content, queue: state.queue }
      }
      return { isOpen: true, content, queue: [] }
    }),
  closePopup: () =>
    set((state) => {
      if (state.queue.length > 0) {
        const [next, ...rest] = state.queue
        return { isOpen: true, content: next, queue: rest }
      }
      return { isOpen: false, content: null, queue: [] }
    }),
}))
